export default "__VITE_ASSET__C7Xz0FNv__"